module.exports = __webpack_public_path__ + "img/erath.71454717.webp";